import { Routes, Route } from 'react-router-dom';
import { Game }    from '../Pages/Game/Game';
import { Classic } from '../Pages/Classic';
import { Error }   from '../Pages/Error';
import './index.css';

export const App = () => {
  return (
    <div className="App-header">
      <Routes>
        {/* Platformer – main experience */}
        <Route path="/"        element={<Game />} />
        {/* Classic plain-HTML fallback for recruiters */}
        <Route path="/classic" element={<Classic />} />
        {/* 404 */}
        <Route path="*"        element={<Error />} />
      </Routes>
    </div>
  );
};
